import React from 'react';

const LinePlaceholder = () => {
  return (
    <div style={{ width: '80%', height: 1, backgroundColor: 'grey', border: '1px solid grey' }} />
  );
};

export { LinePlaceholder };
